import cc from 'classcat';
import React from 'react';

import css from './PlusToMinus.module.scss';

type Props = {
  open: boolean;
};
const PlusToMinus: React.FC<Props> = ({ open = false }) => (
  <svg
    aria-hidden="true"
    className={cc([css.root, { [css.open]: open }])}
    height="14"
    role="presentation"
    viewBox="0 0 14 14"
    width="14"
  >
    <title>Rotating Expand/Collapse Symbols</title>
    <g stroke="none" strokeWidth="1" fillRule="evenodd">
      <path className={css.vertical} d="M14,6 L14,8 L0,8 L0,6 L14,6" />
      <path className={css.horizontal} d="M14,6 L14,8 L0,8 L0,6 L14,6" />
    </g>
  </svg>
);

export default PlusToMinus;
